import { CHALLENGE, CHALLENGE_PHASE } from 'constants/challenges';
import { ChallengePhaseType, ChallengeTypeType } from 'interfaces';

export const getIsDisabledDeal = (
  challengeType: ChallengeTypeType,
  isParticipating: boolean | undefined,
  currentPhase: ChallengePhaseType | null | undefined,
): boolean =>
  challengeType === CHALLENGE.DEAL &&
  (isParticipating === false ||
    (!isParticipating && currentPhase !== CHALLENGE_PHASE.DURING_SIGN_IN));
